export default "__VITE_ASSET__CLtLoph4__"